import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const DEFAULT_PRE_FILTER: {
  [Entities.appointment]: { [key in string]: { $eq: number } }[];
} = {
  [Entities.appointment]: [{ parentId: { $eq: 0 } }],
};
